import { expiringTradePromoRule } from './expiringTradePromoRule';
import { expiringTradePromoAction } from './expiringTradePromoAction';

export const tradePromosConfig = [
    {
        name: 'expiringTradePromo',
        rule: expiringTradePromoRule,
        action: expiringTradePromoAction,
        priority: 445,
    },
];
